import { TrackEvent } from 'livekit-client';
export function getRemoteVideoMuted(publication) {
    return !publication?.track || publication.isMuted || publication.track.isMuted;
}
export function setRemoteVideoMuted(remoteFeed, isMuted) {
    remoteFeed.isVideoMuted = isMuted;
    remoteFeed.onVideoToggle?.(isMuted ? 'off' : 'on');
}
export function subscribeToRemoteVideoState(remoteTrack, onMutedChange) {
    const handleMuted = () => onMutedChange(true);
    const handleUnmuted = () => onMutedChange(false);
    onMutedChange(remoteTrack.isMuted);
    remoteTrack.on(TrackEvent.Muted, handleMuted);
    remoteTrack.on(TrackEvent.Unmuted, handleUnmuted);
    return () => {
        remoteTrack.off(TrackEvent.Muted, handleMuted);
        remoteTrack.off(TrackEvent.Unmuted, handleUnmuted);
    };
}
